define('presentation/common/routeToModal/viewModels/routeToLiveReceptionistScriptViewModel',['common/promises/promiseFactory',
    'businessServices/events/eventManager',
    'businessServices/state/modelStateObserver',
    'common/collections/collectionSorter',
    'common/storage/commonState',
    'constants/autoAttendantVoiceRouteEnumerations',
    'constants/liveReceptionistScriptConstants',
    'constants/liveReceptionistScriptTypeConstants',
    'presentation/common/routeToModal/facades/routeToLiveReceptionistScriptFacade',
    'settings/navigationConfiguration'
], function() {

    return function(initialRoutedToId, initialRouteToType, nameThisOption, routingRuleExitConditions, validateRouteToViewModelCallback) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const SorterConstructor = require('common/collections/collectionSorter');
        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        const _commonState = require('common/storage/commonState');
        const _eventManager = require('businessServices/events/eventManager');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _voiceRouteEnumerations = require('constants/autoAttendantVoiceRouteEnumerations');
        const _i18n = require('i18next');
        const _liveReceptionistScriptConstants = require('constants/liveReceptionistScriptConstants');
        const _liveReceptionistScriptTypeConstants = require('constants/liveReceptionistScriptTypeConstants');

        const _promiseFactory = new PromiseFactoryConstructor();

        let _disposables = [];
        let _facade = null;

        const NONE_LIVE_RECEPTIONIST_SCRIPT_ID = "[None]";
        const NONE_LIVE_RECEPTIONIST_SCRIPT_NAME = _i18n.t('routeToLiveReceptionistScript:none');
        const NONE_LIVE_RECEPTIONIST_SCRIPT = {
            id: NONE_LIVE_RECEPTIONIST_SCRIPT_ID,
            name: NONE_LIVE_RECEPTIONIST_SCRIPT_NAME,
            type: _commonState.types.liveReceptionistScript
        };

        const onSelectedLiveReceptionistScriptChanged = () => {
            self.isValid(!(self.selectedLiveReceptionistScript() && self.selectedLiveReceptionistScript().id === NONE_LIVE_RECEPTIONIST_SCRIPT_ID));
            validateRouteToViewModelCallback({});
        };

        self.addLiveReceptionistScriptUrl = _navigationConfiguration.routesById.addLiveReceptionistScript.url;
        self.createLiveReceptionistScriptLinkText = _i18n.t('routeToLiveReceptionistScript:createLiveReceptionistScript');
        self.noLiveReceptionistScriptsWarningMessage = _i18n.t('routeToLiveReceptionistScript:noLiveReceptionistScriptWarningMessage');
        self.modelStateObserver = new ModelStateObserverConstructor(self, true);
        self.selectedLiveReceptionistScript = ko.observable().extend({observeState: true});
        _disposables.push(self.selectedLiveReceptionistScript.subscribe(onSelectedLiveReceptionistScriptChanged));
        self.routeToStrategy = null;
        self.isNewRouteTo = true;
        self.isValid = ko.observable(false);
        self.showNoLiveReceptionistScriptsWarningMessage = ko.observable(false);
        self.availableLiveReceptionistScripts = ko.observable([]);
        self.placeholderMessage = NONE_LIVE_RECEPTIONIST_SCRIPT_NAME;

        self.liveReceptionistScripts = ko.pureComputed(() => {
            const liveReceptionistScripts = self.availableLiveReceptionistScripts()
                .map((script) => {
                    const id = script.liveReceptionistScriptId;
                    const iconProperty = { iconProperty: _commonState.types.liveReceptionistScript };
                    return Object.assign({}, script, id, iconProperty);
                })
                .filter(script => isActiveLiveReceptionistScript(script) || isSelectedScript(script));

            const sorter = new SorterConstructor();
            sorter.sort(liveReceptionistScripts, "name", true);
            return liveReceptionistScripts;
        });
        self.liveReceptionistScriptsIsEnabled = ko.pureComputed(() => self.liveReceptionistScripts().length > 0);

        const isActiveLiveReceptionistScript = (script) => {
            return script.status === _liveReceptionistScriptConstants.status.active.id &&
                script.scriptType === _liveReceptionistScriptTypeConstants.LiveReceptionist;
        };

        const isSelectedScript = (script) => {
            return self.selectedLiveReceptionistScript() !== null &&
                self.selectedLiveReceptionistScript() !== undefined &&
                self.selectedLiveReceptionistScript().id === script.id;
        };


        self.cancelForm = () => {
            return _promiseFactory.defer((deferredObject) => {
                _eventManager.publishRouteToCloseModal();
                deferredObject.resolve();
            });
        };

        self.detached = () => {
            _disposables.forEach(d => d.dispose());
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/common/routeToModal/facades/routeToLiveReceptionistScriptFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {
            _facade.getLiveReceptionistScripts()
                .done((liveReceptionistScripts) => {
                    self.availableLiveReceptionistScripts(liveReceptionistScripts);

                    if(initialRoutedToId !== null  && initialRouteToType === _voiceRouteEnumerations.liveReceptionistScript) {
                        const liveReceptionistScript = liveReceptionistScripts.find(script => script.id === initialRoutedToId);
                        self.selectedLiveReceptionistScript(liveReceptionistScript);
                    }
                    else if (self.liveReceptionistScripts().length === 0) {
                        self.selectedLiveReceptionistScript(NONE_LIVE_RECEPTIONIST_SCRIPT);
                        self.showNoLiveReceptionistScriptsWarningMessage(true);
                    }
                    else {
                        self.selectedLiveReceptionistScript(self.liveReceptionistScripts()[0]);
                        self.showNoLiveReceptionistScriptsWarningMessage(false);
                    }

                });
            return _promiseFactory.wait();
        };
    };
});

